import {
  INIT_ARCHIVE,
  INIT_ARCHIVE_SESSION,
  INIT_ARCHIVE_FILTERPARAMS,
  REMOVE_ARCHIVE_FILTERPARAMS,
  FILTER_SIGNALS,
  CLEAR_ARCHIVE,
} from '../type';
import axiosInstance from '../../config/axios.config';
import { shouldFilter } from '../../utils/shouldFilter';

export const initArchive = (data) => ({
  type: INIT_ARCHIVE,
  payload: data,
});

export const clearArchive = () => ({
  type: CLEAR_ARCHIVE,
  payload: [],
});

export const initArchiveFilterParams = (data) => ({
  type: INIT_ARCHIVE_FILTERPARAMS,
  payload: data,
});

export const removeArchiveFilterParams = (data) => ({
  type: REMOVE_ARCHIVE_FILTERPARAMS,
  payload: data,
});

export const filterSignals = (filterCriteria) => ({
  type: FILTER_SIGNALS,
  payload: filterCriteria,
});

// получаем сессии с учетом выбранных фильтров
export const initArchiveFromServer = (query) => async (dispatch) => {
  try {
    const result = await axiosInstance(`/api/sessions${query}`);
    if (result.data && result.status === 200) {
      dispatch(initArchive(result.data));
      return result; // Возвращаем данные для использования в .then()
    }
  } catch (error) {
    console.log(error);
  }
};

// записываем сессию в стейт
export const initArchiveSession = (data) => ({
  type: INIT_ARCHIVE_SESSION,
  payload: data,
});

// получаем сессию по id
export const initArchiveSessionFromServer = (id, filterCriteria) => async (dispatch) => {
  try {
    let filteredCriteria = { ...filterCriteria };

    // Удаляем поля, если они равны false
    if (filteredCriteria.btn_alert === false) {
      delete filteredCriteria.btn_alert;
    }
    if (filteredCriteria.btn_clear === false) {
      delete filteredCriteria.btn_clear;
    }
    if (filteredCriteria.fencingBtnServer === false) {
      delete filteredCriteria.fencingBtnServer;
    }
    const filterFlag = shouldFilter(filteredCriteria);
    const { data } = await axiosInstance(`/api/sessions/${id}`);
    if (data) {
      dispatch(initArchiveSession(data));
    }
    if (data && filterFlag) {
      dispatch(filterSignals(filteredCriteria));
    }
  } catch (error) {
    console.log(error);
  }
};
